import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';

export function TitleLink({ titleLink, subtitle = null, headingClassName = null, ariaId = null }) {
  return (
    <Fragment>
      <h3 className={classnames('heading-4', headingClassName)} id={ariaId}>
        {titleLink.url ? (
          <Link
            className="text-primary-darker"
            to={titleLink.url}
            target={titleLink.blank ? '_blank' : null}
            rel={titleLink.nofollow ? 'nofollow' : null}
            data-tracking-id="mmy_select"
          >
            {titleLink.title}
          </Link>
        ) : (
          titleLink.title
        )}
      </h3>
      {!!subtitle && <div className="text-gray-dark medium">{subtitle}</div>}
    </Fragment>
  );
}

TitleLink.propTypes = {
  titleLink: PropTypes.shape({
    url: PropTypes.string,
    blank: PropTypes.bool,
    nofollow: PropTypes.bool,
    title: PropTypes.string,
  }).isRequired,
  subtitle: PropTypes.string,
  headingClassName: PropTypes.string,
  ariaId: PropTypes.string,
};
